<template>
  <div class="newdetail_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ data.title }}
      </div>
    </div>
    <div class="ctn">
      <!-- <vue-editor v-model="data.content" style="display: none"/> -->
      <div
        class="contract_box"
        v-html="data.content"
      />
    </div>
  </div>
</template>

<script>

    import Fetch from "../../utils/fetch";
	import bsHeader from '../../components/bsHeader.vue'

    export default {
        name: "Aritcle",
        components: {bsHeader},
        data() {
            return {
                data: {},
            };
        },
        created() {
            this.$parent.footer('user',false);
        },
        mounted() {
            this.start();
        },
        methods: {
            start() {
                Fetch('/index/article_detail', {
                    id: this.$router.history.current.params.code
                }).then(res => {
                    this.data = res.data;
                })
            },
        }
    };
</script>

<style lang="less" scoped>
    .red_top_bg{
        position: fixed;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        z-index: 10;
    }
	
    .newdetail_wrap {
        min-height: 100vh;
        overflow-x: hidden;
        overflow-y: auto;
        padding-bottom: calc(24px + env(safe-area-inset-bottom));
        background: linear-gradient(160deg, #fffdf7, #fff5e3 60%, #f7e6c5);
    }

    .newdetail_wrap .ctn {
        width: auto;
        margin: 66px 14px 0;
        padding: 16px;
        border: 1px solid rgba(190, 139, 52, .46);
        border-radius: 14px;
        background: #fffdf8;
        box-shadow: 0 10px 24px rgba(125, 82, 35, .08);
    }
	.contract_box{
		color: #533126;
		line-height: 20px;
	}

    .newdetail_wrap .ctn .title {
        font-size: 12px;
        color: #63352c;
        font-weight: bold;
        line-height: 1.7;
    }

    .newdetail_wrap .ctn .info {
        font-size: 12px;
        color: #815c45;
        line-height: 1.7;
    }

    .red_top_bg { height: 54px; background: rgba(255, 252, 245, .97); border-bottom: 1px solid rgba(190, 139, 52, .45); }.red_top_bg .big_tit, .red_top_bg .back_left { color: #873126; }
</style>
